<template>
  <vf-breadcrumbs
    v-if="product && !isElevated"
    :class="brandClasses.breadcrumbs"
    :items="product.breadcrumbs || []"
    :last-step="{ label: product.name }"
  />
</template>

<script lang="ts" setup>
import VfBreadcrumbs from '#brands/components/vf/breadcrumbs/Breadcrumbs.vue'

const { $feature } = useNuxtApp()
const { product } = usePdp()
const { brandClasses } = useAppConfig().pages.pdp

const isElevated = computed(() => product.value?.elevatedPDPDetails?.enable || false)

if ($feature.tempShowATCAboveFold)
  brandClasses.breadcrumbs = 'my-2 text-sm container lg:mt-0 lg:mb-4'
</script>
